import { css } from 'emotion';
import Link from 'next/link';
import React from 'react';

import analytics from 'site-react/core/Analytics';

import useMembership from 'site-react/hooks/useMembership';
import useUser from 'site-react/hooks/useUser';

import theme from 'site-react/theme';

const wrapperStyle = css`
  ${theme.contentText3}

  background-color: ${theme.colors.neutral900};
  color: ${theme.colors.white};
  display: inline-block;
  padding: ${theme.spacing.base * 3}px ${theme.spacing.sm}px
    ${theme.spacing.base * 3}px ${theme.spacing.md}px;
  margin: 0;
  width: 100%;

  &:hover,
  &:focus {
    color: ${theme.colors.neutral50};
    text-decoration: none;
  }

  &:active {
    color: ${theme.colors.neutral100};
  }
`;

const fakeLinkStyle = css`
  ${theme.contentText3}
  color: ${theme.colors.brandPrimary};
  text-decoration: underline;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;

const FreeTrialBanner = () => {
  const { isLoggedIn, user } = useUser();
  const { freeTrialDaysRemaining } = useMembership();

  if (
    !isLoggedIn ||
    !user.organisation ||
    (freeTrialDaysRemaining !== 0 && !freeTrialDaysRemaining)
  ) {
    return null;
  } else {
    let contentText;

    if (freeTrialDaysRemaining < 0) {
      contentText = 'Your free trial has expired.';
    } else if (freeTrialDaysRemaining === 0) {
      contentText = 'Free trial ends today.';
    } else if (freeTrialDaysRemaining === 1) {
      contentText = 'Free trial ends in 1 day.';
    } else {
      contentText = `Free trial ends in ${freeTrialDaysRemaining} days`;
    }

    if (user.role === 'admin') {
      return (
        <Link href="/membership/admin">
          {/* `href` is populated by next/link */}
          {/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
          <a
            onClick={() => analytics.track('Upgrade Free Trial Banner Clicked')}
          >
            <span className={wrapperStyle}>
              <b>{contentText} </b>
              <span className={fakeLinkStyle}>Upgrade now</span>
            </span>
          </a>
        </Link>
      );
    } else {
      return (
        <span className={wrapperStyle}>
          <b>{contentText}</b>
        </span>
      );
    }
  }
};

export default FreeTrialBanner;
